
import Vue from 'vue';
import PianoCustomerStateHandler from '@piano/components/PianoCustomerStateHandler.vue';
import Podcast from '@root/modules/podcast/components/fragments/Podcast.vue';
import { Podcast as IPodcast } from '@root/modules/podcast/types/podcast';
import getPodcastWithHref from '@root/modules/podcast/utils/getPodcastWithHref';
import Swiper from '@core/components/UI/swiper/Swiper.vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import isMobileView from '@root/common/utils/isMobileView';

interface Data {
  data: IPodcast[];
  isMobileView: boolean;
  swiperOptions: Record<string, any>;
}

interface Computed {
  customerPlaylist: IPodcast[];
  customerToken: string | null;
  items: IPodcast[];
}

interface Methods {
  getCustomerPlaylist: () => void;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  components: {
    PianoCustomerStateHandler,
    Podcast,
    Swiper,
    LinkHandler,
  },
  data() {
    return {
      data: [],
      isMobileView: false,
      swiperOptions: {
        spaceBetween: 24,
        initialSlide: 0,
        autoplay: false,
        loop: false,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        pagination: {
          enabled: false,
        },
        navigation: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        simulateTouch: false,
        breakpoints: {
          768: {
            freeMode: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1230: {
            freeMode: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
      },
    };
  },
  computed: {
    customerPlaylist() {
      return this.$store.state.podcast.customerPlaylist || [];
    },
    customerToken() {
      return this.$store.state.piano.token;
    },
    items() {
      let data = [...this.customerPlaylist];

      if (this.customerPlaylist.length) {
        const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
        const podcastsWithHref = data.map((podcast: IPodcast) => {
          const { domain } = this.$channelConfig('settings');
          return getPodcastWithHref({ podcast, domain, fakeDomainEnabled });
        });

        data = podcastsWithHref;
      }

      return data;
    },
  },
  watch: {
    async customerToken() {
      if (this.customerToken) {
        await this.$store.dispatch('podcast/setCustomerToken', this.customerToken);
        await this.getCustomerPlaylist();
      }
    },
  },
  methods: {
    async getCustomerPlaylist() {
      await this.$store.dispatch('podcast/setCustomerPlaylist');
    },
  },
  async mounted() {
    this.isMobileView = isMobileView();

    if (this.customerToken) {
      await this.$store.dispatch('podcast/setCustomerToken', this.customerToken);
      await this.getCustomerPlaylist();
    }
  },
});
